import { styled } from "@mui/material/styles";
import { useState, useCallback, useEffect } from "react";
import { MenuRounded, MenuOpenRounded } from "@mui/icons-material";
import { useMediaQuery, IconButton, Drawer, } from "@mui/material";

import CommunityMenuBar from "../CommunityMenuBar";
import { Box, Typography } from "@maysoft/common-component-react";
import "./index.css";



export const RemoveOverflowYDrawer = styled(Drawer)(() => ({
    ".MuiDrawer-paper": {
        overflowY: undefined,
        width: "fit-content !important",
    }
}));

const CommunityCommonLayout = (props: {
    children: React.ReactNode;
    titleChildren?: string;
}) => {
    const isMobileScreenMediaQuery = useMediaQuery('(max-width: 600px)');
    const [isMenuExpanded, setIsMenuExpanded] = useState(false);

    const onCloseMenu = useCallback(() => {
        setIsMenuExpanded(false);
    }, []);

    useEffect(() => {
        !isMobileScreenMediaQuery && setIsMenuExpanded(false);
    }, [isMobileScreenMediaQuery]);

    return (
        <>
            <div className="acr--curriculum-layout--root--container"
                style={{
                    backgroundColor: "transparent"
                }}
            >
                <div className={
                    isMobileScreenMediaQuery
                        ? "acr--curriculum-menu--wrapper acr--collapsed"
                        : "acr--curriculum-menu--wrapper"
                }
                >
                    <CommunityMenuBar />
                </div>

                {isMobileScreenMediaQuery && (
                    <RemoveOverflowYDrawer
                        anchor="left"
                        open={isMenuExpanded}
                        onClose={onCloseMenu}
                    >
                        <CommunityMenuBar />
                    </RemoveOverflowYDrawer>
                )}

                <div className="acr--curriculum-layout--content--root">
                    {
                        isMobileScreenMediaQuery &&
                        <Box style={{ display: "flex", alignItems: "center" }}>
                            <IconButton sx={{ mr: 2 }} onClick={() => {
                                setIsMenuExpanded(!isMenuExpanded);
                            }} size="small">
                                {isMenuExpanded ? <MenuRounded /> : <MenuOpenRounded />}
                            </IconButton>
                            <Typography
                                color="dark"
                                lineHeight={0}
                                variant="button"
                                textTransform="none"
                            >
                                {props.titleChildren || ""}
                            </Typography>
                        </Box>
                    }
                    {props.children}
                </div>
            </div>
        </>
    );
};

export default CommunityCommonLayout;